import { DateUtils } from "@app/core/shared/domain/date.utils";

export class DateMapper {
  /**
   * Convert Date string to Date
   * @param dateString Example: 2023-03-28 09:00:00+00:00
   */
  static deserialize(dateString: string): Date {
    return DateUtils.parse(dateString.substring(0, 19), "yyyy-MM-dd HH:mm:ss");
  }

  /**
   * Convert Date string without hour to Date
   * @param dateString Example: 2023-03-28
   */
  static deserializeBasicDate(dateString: string): Date {
    return DateUtils.parse(dateString, "yyyy-MM-dd");
  }
}
